import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Typography from '../Typography'
import classes from './addon-item.module.sass'

const AddonItem = ({ text, price, onClick, active }) => (
  <button
    type="button"
    className={cn(classes.addonItem, active ? classes.active : '')}
    onClick={onClick}
  >
    <Typography weight={600}>{text}</Typography>
    <Typography weight={600}>{price}</Typography>
  </button>
)

AddonItem.defaultProps = {
  active: false,
}

AddonItem.propTypes = {
  text: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
}

export default AddonItem
